import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { bankList, gaoDaAgree } from '../../../../api/apis';
export default {
  data: function data() {
    return {
      dialogVisible: false,
      bankList: [],
      form: {
        bankId: ''
      }
    };
  },
  mounted: function mounted() {},
  methods: {
    show: function show(row, finish) {
      var _this = this;

      this.id = row.id;
      this.dialogVisible = true;
      this.finish = finish;
      this.form = {
        bankId: ''
      };
      bankList({
        number: row.number
      }).then(function _callee(res) {
        var i;
        return regeneratorRuntime.async(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.bankList = res;
                _context.t0 = regeneratorRuntime.keys(res);

              case 2:
                if ((_context.t1 = _context.t0()).done) {
                  _context.next = 9;
                  break;
                }

                i = _context.t1.value;

                if (!(res[i].is_default == 1)) {
                  _context.next = 7;
                  break;
                }

                _this.form.bankId = res[i].id;
                return _context.abrupt("break", 9);

              case 7:
                _context.next = 2;
                break;

              case 9:
              case "end":
                return _context.stop();
            }
          }
        });
      });
    },
    clickSubmit: function clickSubmit() {
      var _this2 = this;

      if (this.form.bankId === '') {
        this.$message({
          message: '请选择银行卡号',
          type: 'error'
        });
        return;
      }

      this.$g.fun.startLoading('');
      var bankData = null;

      for (var i in this.bankList) {
        if (this.bankList[i].id === this.form.bankId) {
          bankData = this.bankList[i];
          break;
        }
      }

      gaoDaAgree({
        id: this.id,
        status: 1,
        bank_no: bankData.no,
        bank_branch: bankData.bank_branch,
        bank_code: bankData.bank_code
      }).then(function _callee2(res) {
        return regeneratorRuntime.async(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$message({
                  type: 'success',
                  message: '操作成功'
                });

                _this2.$g.fun.endLoading();

                _this2.dialogVisible = false;

                _this2.finish();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        });
      });
    }
  }
};